// Dynamic Tenant Configuration - ไม่ hardcode ใน component
// จัดการ mapping ระหว่าง TENANT_ID และ default theme

export interface TenantConfig {
    id: string
    name: string
    defaultTheme: string
    description?: string
    features?: string[]
}

// ⚡ Central Tenant Registry - เพิ่ม tenant ใหม่ที่นี่
export const TENANT_CONFIGS: Record<string, TenantConfig> = {
    'demo-tenant-01': {
        id: 'demo-tenant-01',
        name: 'Demo Tenant 01',
        defaultTheme: 'huay-asia',
        description: 'ผู้เช่าทดสอบ 01 - ใช้ธีม HuayAsia',
        features: ['basic-lottery', 'wallet']
    },
    'demo-tenant-02': {
        id: 'demo-tenant-02',
        name: 'Demo Tenant 02',
        defaultTheme: 'huay-fast',
        description: 'ผู้เช่าทดสอบ 02 - ใช้ธีม HuayFast',
        features: ['basic-lottery', 'wallet', 'promotions']
    },
    'test-demo-01': {
        id: 'test-demo-01',
        name: 'Test Demo 01',
        defaultTheme: 'huay-asia', // หรือ theme ที่ต้องการ
        description: 'ผู้เช่าทดสอบสำหรับ frontend/admin',
        features: ['basic-lottery', 'wallet', 'admin-panel']
    }
    // 🚀 เพิ่ม tenants ใหม่ได้ที่นี่
    // 'production-tenant-01': {
    //   id: 'production-tenant-01',
    //   name: 'Production Tenant 01',
    //   defaultTheme: 'huay-premium',
    //   description: 'ผู้เช่าจริงใน production',
    //   features: ['full-lottery', 'wallet', 'promotions', 'analytics']
    // }
}

// Helper functions
export const getTenantConfig = (tenantId: string): TenantConfig | null => {
    return TENANT_CONFIGS[tenantId] || null
}

export const getDefaultThemeForTenant = (tenantId: string): string => {
    const config = getTenantConfig(tenantId)
    return config?.defaultTheme || 'huay-asia' // fallback to default theme
}

export const getAllTenants = (): TenantConfig[] => {
    return Object.values(TENANT_CONFIGS)
}

export const getTenantIds = (): string[] => {
    return Object.keys(TENANT_CONFIGS)
}

// สำหรับ production สามารถใช้ function นี้เพื่อดึงจาก API
export const loadTenantsFromAPI = async (): Promise<Record<string, TenantConfig>> => {
    try {
        // ในอนาคตเรียก API ตรงนี้
        // const response = await fetch('/api/tenants/config')
        // return await response.json()

        // ตอนนี้ return static config
        return TENANT_CONFIGS
    } catch (error) {
        console.error('Failed to load tenants from API, using fallback:', error)
        return TENANT_CONFIGS
    }
}
